import Audio from '~/Audio';
import { logError } from '~/logger';
import messages, { GameStateStoreMessage } from '~/flux/stores/GameStateStore/messages';
import mutationUseHeroXpBoost from '~/graphql/hero/mutationUseHeroXpBoost';

export default async function useHeroXpBoost(
  {
    playerId,
    setInventoryAndHeroRoster,
    emit,
  }: {
    playerId: string;
    setInventoryAndHeroRoster: (data: { inventory?: unknown; hero_roster?: unknown; }) => void;
    emit: (event: GameStateStoreMessage) => void;
  },
  action: { potionId: string; heroHandle: string; }
) {
  try {
    const data = await mutationUseHeroXpBoost({
      playerId,
      potionId: action.potionId,
      heroHandle: action.heroHandle,
    });

    setInventoryAndHeroRoster({
      ...(data.inventory != null && { inventory: data.inventory }),
      ...(data.hero_roster != null && { hero_roster: data.hero_roster }),
    });

    emit(messages.EQUIPMENT_CHANGE);
    emit(messages.XP_BOOST_USED);

    Audio.play('level_up');
  } catch (err) {
    logError(err, {
      module: 'GameStateStore',
      func: 'useHeroXpBoost',
      playerId,
      action: JSON.stringify(action),
    });
  }
}
